// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"2e2b194e","453":"841296c2","701":"81ce86cb","756":"6c768386","945":"f0fe9402"}[chunkId] + ".chunk.js";
};